import React, { useEffect, useState } from "react";
import "./myunstaking.scss";
import { Pagination, Modal } from "react-bootstrap";
import axios from "axios";
import { useWeb3React } from "@web3-react/core";
import environment from "../../utils/Enviroment";
import CountdownTimer from "./CountdownTimer";
import CooldownTimer from "./CountdownTimer";
import { getClaimingContract } from "../../utils/contractHelpers";
import useWeb3 from "../../hooks/useWeb3";
import { toast } from "react-toastify";
import Loader from "../../hooks/loader";
// import { Pagination, Modal } from "react-bootstrap";

const Myunstaking = ({ indexwaits, setShow111 }) => {
  const currencyFormatter = require("currency-formatter");
  const web3 = useWeb3();

  const { account } = useWeb3React();
  const [show, setShow] = useState(false);
  const [activeDeposit, setActiveDeposit] = useState([]);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [text, settext] = useState("Loading");
  const pageSize = 10;

  const [withdrawAmount, setWithdrawAmount] = useState(0);
  const [timersUp, setTimersUp] = useState(
    Array(activeDeposit.length).fill(false)
  );
  const [mainLoader, setMainLoader] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // const [timeIsUp, setTimeIsUp] = useState(false);
  const [activeDepositCount, setActiveDepositCount] = useState(1);

  // const [timeIsUpState, setTimeIsUpState] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null); // State to store selected index
  const [recall, setRecall] = useState(false);
  const [timeIsUpState, setTimeIsUpState] = useState([]);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
  };
  const handleShow2 = () => setShow2(true);

  const [show8, setShow8] = useState(false);
  const handleClose8 = () => setShow8(false);
  const handleShow8 = () => setShow8(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setTimeIsUpState([]);
    // Initialize timeIsUpState based on the length of deposits
    setTimeIsUpState(Array(activeDeposit.length).fill(false));
  }, [activeDeposit.length, currentPage]);

  useEffect(() => {
    if (account && currentPage === 1 && indexwaits === "MYUNSTAKING") {
      getDepositData(currentPage, pageSize);
      getDepositDataAmount();

      setRecall(true);
    } else if (account && indexwaits === "MYUNSTAKING") {
      getDepositData(currentPage, pageSize);
    } else {
      setActiveDeposit([]);
    }
  }, [account, indexwaits, currentPage, recall]);

  const getDepositDataAmount = () => {
    // setMainLoader(true);
    let acc = JSON.stringify(account);
    const first = 1000;
    var data = JSON.stringify({
      query: `query MyQuery {
        requestSets(where: {claimer: ${acc}}, first: ${first}) {
            id
          }
        }
      `,
    });
    var config = {
      method: "post",
      url: environment.StackGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        setActiveDepositCount(response?.data?.data?.requestSets?.length);
        // setMainLoader(false);
      })
      .catch(function (error) {
        // setMainLoader(false);
      });
  };
  const getDepositData = (page = 1, pageSize = 5) => {
    const skip = (page - 1) * pageSize;
    const first = pageSize;
    setMainLoader(true);
    settext("Fetching your UnStaking data....");
    const acc = JSON.stringify(account);
    const data = JSON.stringify({
      query: `
      query MyQuery {
        requestSets(where: {claimer: ${acc}},first: ${first}, skip: ${skip}, orderBy: blockTimestamp, orderDirection: desc ) {
          index
          status
          amount
          claimRequestTime
          blockTimestamp
        }
      }`,
    });

    const config = {
      method: "post",
      url: environment.StackGraph,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    axios(config)
      .then((response) => {
        const deposits = response?.data?.data?.requestSets || [];

        setActiveDeposit(response?.data?.data?.requestSets || 0);
        setTotalItems(deposits.length);
        setMainLoader(false);
        settext("Loading...");
      })
      .catch((error) => {
        setMainLoader(false);
        settext("Loading...");
        console.error(error);
      });
  };

  const handleTimerComplete = (index) => {
    setTimeIsUpState((prevState) => {
      const newState = [...prevState];
      newState[index] = true;

      return newState;
    });
  };

  const withdraw = async (index) => {
    if (!account) {
      toast.error("Please Connect Your Wallet First");
      console.error("Please Connect Your Wallet First");
      return;
    }

    try {
      settext("Confirm Widhraw Transaction And Wait...");
      setMainLoader(true);

      const contractAddress = environment?.ClamingContract;
      const contract = getClaimingContract(contractAddress, web3);

      var gasFunPrice;
      web3.eth.getGasPrice().then((result) => {
        var result2 = parseInt(result) + 3000000000;
        gasFunPrice = result2.toString();
      });

      const gas = await contract?.methods
        ?.claimRequest(index)
        ?.estimateGas({ from: account });
      const gaslimit = gas + parseInt(15000)



      // const gasPrice = await web3.eth.getGasPrice();
      // const gasPriceWithBuffer = parseInt(gasPrice) + 3000000000;

      const responce = await contract.methods
        ?.claimRequest(index)
        ?.send({ from: account, gas: gaslimit, gasPrice: gasFunPrice });
      if (responce) {
        // toast.success("DOP's Withdrawl Successfully");

        getDepositData(currentPage, pageSize);
        getDepositDataAmount();
        handleShow2();
        setMainLoader(false);
        settext("Loading...");
      }
      // console.log("Withdraw successful");
    } catch (error) {
      handleShow8();
      // toast.error("Error while withdrawing");
      setMainLoader(false);
      settext("Loading...");
      console.error("Error while withdrawing:", error);
    }
  };

  // const paginatedData = activeDeposit.slice(
  //   (page - 1) * pageSize,
  //   page * pageSize
  // );
  const totalPages = Math.ceil(totalItems / pageSize);

  return (
    <>
      {mainLoader && <Loader text={text} />}
      <section className="parentmain">
        {account ?
          (
            <div className="custom-container paddmobilezero p-0">
              <div className="parentbar tabelmain">
                <h1 className="headingtable">My Unstakings</h1>
                <div className="maintablehaed">
                  <div className="innertable_user table-responsive">
                    <table>
                      <thead className="headtablee">
                        <tr>
                          <th>Date</th>
                          <th>Amount Staked</th>
                          <th>Cooldown Period</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="tablebody">
                        {activeDeposit?.map((deposit, index) => (
                          <tr key={index}>
                            <td className="datatableone">
                              <div className="mainimgdiv">
                                <p className="tabletext">
                                  {new Date(
                                    deposit?.blockTimestamp * 1000
                                  ).toLocaleDateString()}
                                </p>
                                <p className="secondtabletext">
                                  {new Date(
                                    deposit?.blockTimestamp * 1000
                                  ).toLocaleTimeString()}
                                </p>
                              </div>
                            </td>
                            <td className="datatableone addclass">
                              {(deposit?.amount / 1e18).toLocaleString()} DOP
                            </td>
                            {/* {timeIsUpState ? ( */}
                            {timeIsUpState[index] ? (
                              <td
                                className="datatableone secondclassagain"
                                key={index}
                              >
                                <CountdownTimer
                                  setTimeIsUp={() => handleTimerComplete(index)}
                                  targetEpochTime={deposit?.claimRequestTime}
                                />
                              </td>
                            ) : (
                              <td className="datatableone secondclass">
                                <CountdownTimer
                                  setTimeIsUp={() => handleTimerComplete(index)}
                                  targetEpochTime={deposit?.claimRequestTime}
                                />
                              </td>
                            )}
                            <td className="datatableone">
                              {timeIsUpState[index] && deposit.status ? (
                                <button
                                  onClick={() => {
                                    setWithdrawAmount(
                                      (deposit?.amount / 1e18).toLocaleString()
                                    );
                                    setSelectedIndex(deposit.index); // Set the selected index
                                    handleShow();
                                  }}
                                  className="thirdclass2"
                                >
                                  WITHDRAW
                                </button>
                              ) : (
                                <button className="thirdclass" disabled>
                                  {deposit.status ? "Withdraw disabled" : "Claimed"}
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {
                    activeDepositCount > 0 && <div className="Paginationlattable">
                      <div className="left-f">
                        {/* <h6>SHOWING 1-10 OF 10</h6> */}
                      </div>
                      <div className="pagination">
                        <Pagination>
                          <Pagination.Prev
                            onClick={() =>
                              setCurrentPage((prev) => Math.max(prev - 1, 1))
                            }
                          />
                          {[
                            ...Array(Math.ceil(activeDepositCount / pageSize)).keys(),
                          ].map((number) => (
                            <Pagination.Item
                              key={number + 1}
                              active={number + 1 === currentPage}
                              onClick={() => setCurrentPage(number + 1)}
                            >
                              {number + 1}
                            </Pagination.Item>
                          ))}
                          <Pagination.Next
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                          />
                        </Pagination>
                      </div>
                    </div>
                  }



                  {/* <div className="right-f">
                <Pagination>
                  <Pagination.Prev
                    onClick={() => {
                      setCurrentPage((prev) => Math.max(prev - 1, 1));
                      // setTimeIsUpState([]);
                    }}
                  />
                  {[
                    ...Array(Math.ceil(activeDepositCount / pageSize)).keys(),
                  ].map((number) => (
                    <Pagination.Item
                      key={number + 1}
                      active={number + 1 === currentPage}
                      onClick={() => {
                        setCurrentPage(number + 1);
                        // setTimeIsUpState([]);
                      }}
                    >
                      {number + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() => {
                      setCurrentPage((prev) => prev + 1);
                      // setTimeIsUpState([]);
                    }}
                  />
                </Pagination>
              </div> */}
                </div>
              </div>
              <div className="mainheadphone d-none">
                <h1 className="headingstalking">My Unstakings</h1>
                <div>
                  {activeDeposit?.map((deposit, index) => (
                    <div className="cardone" key={index}>
                      <div className="flexclass">
                        <div className="headdate">
                          <p className="dateclass">DATE</p>
                          <p className="dateclasstwo">
                            {new Date(
                              deposit.blockTimestamp * 1000
                            ).toLocaleDateString()}
                          </p>
                        </div>
                        <div>
                          <p className="amount">AMOUNT STAKED</p>
                          <p className="digits">
                            {(deposit?.amount / 1e18).toLocaleString()} DOP
                          </p>
                        </div>
                      </div>
                      <p className="cooldown">Cooldown Period</p>

                      <div
                        key={index}
                      // className={
                      //   timersUp[index] ? "secondclassagain" : "secondclass"
                      // }
                      >
                        {timeIsUpState[index] ? (
                          <p className="datatableone secondclassagain" key={index}>
                            <CountdownTimer
                              setTimeIsUp={() => handleTimerComplete(index)}
                              targetEpochTime={deposit?.claimRequestTime}
                            />
                          </p>
                        ) : (
                          <p className="datatableone secondclass" key={index}>
                            <CountdownTimer
                              setTimeIsUp={() => handleTimerComplete(index)}
                              targetEpochTime={deposit?.claimRequestTime}
                            />
                          </p>
                        )}
                      </div>
                      {timeIsUpState[index] && deposit.status ? (
                        <button
                          onClick={() => {
                            setWithdrawAmount(
                              (deposit?.amount / 1e18).toLocaleString()
                            );
                            setSelectedIndex(deposit.index); // Set the selected index
                            handleShow();
                          }}
                          className="thirdclass2 withdrawbtnmbl mt-2"
                        >
                          WITHDRAW
                        </button>
                      ) : (
                        <button className="thirdclass disabledbtnmbl mt-2" disabled>
                          {deposit.status ? "Withdraw disabled" : "Claimed"}
                        </button>
                      )}
                    </div>
                  ))}
                </div>
                {
                  activeDepositCount > 0 && <div className="Paginationlattable">
                    <div className="left-f">{/* <h6>SHOWING 1-10 OF 10</h6> */}</div>
                    <div className="pagination">
                      <Pagination>
                        <Pagination.Prev
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                        />
                        {[
                          ...Array(Math.ceil(activeDepositCount / pageSize)).keys(),
                        ].map((number) => (
                          <Pagination.Item
                            key={number + 1}
                            active={number + 1 === currentPage}
                            onClick={() => setCurrentPage(number + 1)}
                          >
                            {number + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                        />
                      </Pagination>
                    </div>
                  </div>
                }

              </div>
            </div>
          )
          :
          (
            <div className="stakingstatbox">
              <div className="wrapper">
                <h6>You haven't connected your wallet yet.</h6>
                <p className="whitetext">Click here to connect your wallet.</p>
                <button className="waletconnectss" onClick={() => { setShow111(true) }}><svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                  <path d="M14.667 11.667H14.677" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.33333 5.83333H16.3333C16.7754 5.83333 17.1993 6.00893 17.5118 6.32149C17.8244 6.63405 18 7.05797 18 7.5V15.8333C18 16.2754 17.8244 16.6993 17.5118 17.0118C17.1993 17.3244 16.7754 17.5 16.3333 17.5H4.66667C4.22464 17.5 3.80072 17.3244 3.48816 17.0118C3.17559 16.6993 3 16.2754 3 15.8333V4.16667C3 3.72464 3.17559 3.30072 3.48816 2.98816C3.80072 2.67559 4.22464 2.5 4.66667 2.5H16.3333" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>Connect Wallet</button>
              </div>
            </div>
          )
        }


      </section>
      <Modal
        className="generic-modal"
        show={show}
        onHide={handleClose}
        centered
      >
        <img src="\assets\modalshadow.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Withdraw</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="headmodal">
            <p className="paragraphmodal">Withdraw Amount</p>
            <h1 className="headingmodal">
              {withdrawAmount ? withdrawAmount : 0} DOP
            </h1>
          </div>
          <div className="divmid">
            {/* <p className="feediv">Transaction Fee</p>
            <p className="numdiv">$8.522 (0.01 ETH)</p> */}
          </div>
          <div className="mainbtns">
            <button className="dullbtn" onClick={handleClose}>
              Cancel
            </button>
            <button
              className="brdrbtn"
              onClick={() => {
                withdraw(selectedIndex); // Call the withdraw function with the selected index
                handleClose();
              }}
            >
              WITHDRAW
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <img src="\assets\modalshadowgreen.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Withdraw</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="happy">
            <img
              src="\assets\happy.png"
              alt="img"
              className="img-fluid formsrgin"
              style={{ marginTop: "10px" }}
            />
            <h6 style={{ marginTop: "30px", color: "#27A57F", fontSize: "18px" }}>Withdraw Amount successfully</h6>
            <h5><svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
              <path d="M18 0.5C27.942 0.5 36 8.55958 36 18.5C36 28.442 27.942 36.5 18 36.5C8.05958 36.5 0 28.4412 0 18.5C0 8.55958 8.05958 0.5 18 0.5Z" fill="#131313" />
              <path d="M10.4473 9.82275H18.9025C21.263 9.82275 23.5268 10.737 25.1959 12.3644C26.865 13.9918 27.8027 16.199 27.8027 18.5005C27.8027 20.802 26.865 23.0092 25.1959 24.6366C23.5268 26.264 21.263 27.1782 18.9025 27.1782V22.7294C20.0528 22.7294 21.156 22.2838 21.9694 21.4908C22.7828 20.6977 23.2398 19.6221 23.2398 18.5005C23.2398 17.3789 22.7828 16.3033 21.9694 15.5102C21.156 14.7172 20.0528 14.2716 18.9025 14.2716V14.2729H14.4524V18.278H10.4473V9.82275Z" fill="white" />
              <rect x="14.4558" y="18.2964" width="4.4085" height="4.4085" fill="white" />
            </svg>{withdrawAmount ? withdrawAmount : 0} <span>DOP</span></h5>
            <button className="commonbtn" onClick={handleClose2} style={{ background: "rgba(215, 230, 238, 0.20)", border: "1px solid #EDF3F7" }}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="generic-modal stakingmodals"
        show={show8}
        onHide={handleClose8}
        centered
      >
        <img src="\assets\modalshadowerror.png" alt="img" className="img-fluid modalshadow" />
        <Modal.Header closeButton>
          <Modal.Title>Claim Rewards</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="happy">
            <img
              src="\assets\vector.png"
              alt="img"
              className="img-fluid 
formsrgin"
            />

            <p className="wrong" style={{ color: "#BF3436", fontSize: "18px", fontWeight: "500", textTransform: "capitalize" }}>Oops, something went wrong</p>
            <button className="commonbtn" onClick={handleClose8}>
              Try again
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Myunstaking;
